import { createContext, useContext, useState, useCallback } from "react";
import axiosInstance from "../Config/axios";
import Loader from "../Components/Loader/Loader";

const NewUserContext = createContext();
export const useNewUser = () => useContext(NewUserContext);

export const NewUserContextProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  const fetchPracticeListing = useCallback(async () => {
    try {
      const response = await axiosInstance.get("practice_listings/");
      if (response.data.status === "success") {
        return response.data.data;
      }
    } catch (err) {
      console.log("Error fetching practice listings:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchPracticeListingByIDs = useCallback(async (ids) => {
    try {
      const response = await axiosInstance.get(
        `practice_listings/?record_ids=${ids}`,
      );
      if (response.data.status === "success") {
        return response.data.data;
      }
    } catch (err) {
      console.log("Error fetching practice listings by IDs:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  // Moved inside provider, uses axiosInstance, returns locations array
  const fetchLocations = useCallback(async () => {
    try {
      const response = await axiosInstance.get("get_locations");
      if (
        response.data?.status === "success" &&
        Array.isArray(response.data?.locations)
      ) {
        return response.data; // { status, locations: [{id, name, slug, default_image}] }
      }
      return { locations: [] };
    } catch (err) {
      console.error("Error fetching locations:", err);
      return { locations: [] };
    }
  }, []);

  return (
    <NewUserContext.Provider
      value={{
        fetchPracticeListing,
        fetchPracticeListingByIDs,
        fetchLocations, // Exposed here
      }}
    >
      {loading && <Loader />}
      {children}
    </NewUserContext.Provider>
  );
};
